import { Account, ClosedPosition, OpenPosition } from '@monorepo/types';
import {
  ACCOUNT_QUERY_KEYS,
  ACCOUNT_STALE_TIME,
  DEFAULT_POSITIONS_LIMIT,
  DEFAULT_POSITIONS_PAGE,
} from '../constants';

export const createAllPositionsQuery = (
  positionStore: {
    getAllPositions: (
      tsAccountId: string,
      options?: { page: number; limit: number },
    ) => Promise<{ results: (OpenPosition | ClosedPosition)[]; total: number }>;
  },
  account: Account | undefined,
  page = DEFAULT_POSITIONS_PAGE,
  limit = DEFAULT_POSITIONS_LIMIT,
  enabled = true,
) => ({
  queryKey: ACCOUNT_QUERY_KEYS.ALL_POSITIONS(
    account?.tsAccountId || '',
    page,
    limit,
  ),
  queryFn: async () => {
    if (!account?.tsAccountId) throw new Error('Account ID is required');
    return positionStore.getAllPositions(account.tsAccountId, {
      page,
      limit,
    });
  },
  staleTime: ACCOUNT_STALE_TIME,
  enabled: enabled && !!account?.tsAccountId,
});
